"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.canOfferFlight = exports.prepareFlightDetailsDataFromFlightOffer = exports.getTotalCost = exports.getCityToCityText = exports.filterItemsByTab = exports.getFlightUrl = exports.getPostTitle = exports.renderPassengerRequestPostTitle = exports.renderPilotFlightPostTitle = exports.filterFlights = exports.onConfirmRatePassengers = exports.confirmRatePassengersDisabled = exports.changeComment = exports.changeUserRating = exports.showRateButton = exports.getUserIsFlightPilot = exports.getMyFlightsTabs = void 0;
const lodash_1 = require("lodash");
const flightHandlers_1 = require("../handlers/flightHandlers");
const dictionaries_1 = require("./dictionaries");
const config_1 = require("../config/config");
const moment_1 = __importDefault(require("moment/moment"));
const utils_1 = require("./utils");
const getMyFlightsTabs = (t) => [
    { name: 'all', label: t('tab_web.all') },
    { name: 'ongoing', label: t('tab_web.ongoing') },
    { name: 'pending', label: t('tab_web.pending') },
    { name: 'completed', label: t('tab_web.completed') },
    { name: 'canceled', label: t('tab_web.canceled') }
];
exports.getMyFlightsTabs = getMyFlightsTabs;
const getUserIsFlightPilot = (user, flightData) => user.id === flightData.pilot?.app_user?.id;
exports.getUserIsFlightPilot = getUserIsFlightPilot;
const showRateButton = (flightData, user) => {
    if (!flightData.isCompleted)
        return false;
    else if ((0, exports.getUserIsFlightPilot)(user, flightData))
        return !flightData.pilot.rated && flightData.passengersCount > 0;
    else {
        const passenger = flightData.flight_passengers.find(passenger => passenger.id === user.id);
        return !passenger?.rated;
    }
};
exports.showRateButton = showRateButton;
const changeUserRating = ({ id, rating, userRatings, setUserRatings }) => {
    const updatedRatings = userRatings.map(userRating => (userRating.id === id ? { ...userRating, rating } : userRating));
    setUserRatings(updatedRatings);
};
exports.changeUserRating = changeUserRating;
const changeComment = ({ id, comment, userRatings, setUserRatings }) => {
    const updatedRatings = userRatings.map(userRating => (userRating.id === id ? { ...userRating, comment } : userRating));
    setUserRatings(updatedRatings);
};
exports.changeComment = changeComment;
const confirmRatePassengersDisabled = (userRatings) => (0, lodash_1.every)(userRatings, user => !(user.rating > 0));
exports.confirmRatePassengersDisabled = confirmRatePassengersDisabled;
const onConfirmRatePassengers = ({ flightId, userRatings, setShowConfirm, setModalVisible }) => {
    if ((0, lodash_1.some)(userRatings, user => !(user.rating > 0))) {
        setShowConfirm(true);
    }
    else {
        setModalVisible(false);
        (0, flightHandlers_1.ratePassengersHandler)(flightId, userRatings);
    }
};
exports.onConfirmRatePassengers = onConfirmRatePassengers;
const filterFlights = (flightData, offers, activeTab) => {
    const flightStatusMap = {
        completed: [dictionaries_1.FlightStatus.CLOSED, dictionaries_1.FlightStatus.DONE],
        ongoing: [dictionaries_1.FlightStatus.NEW, dictionaries_1.FlightStatus.OPEN],
        canceled: [dictionaries_1.FlightStatus.CANCELED],
        pending: []
    };
    const filteredFlights = flightData.filter((flight) => {
        if (activeTab === 'all') {
            return true;
        }
        if (flight.request && flight.status == dictionaries_1.FlightStatus.NEW)
            return activeTab === 'pending';
        const flightStatuses = flightStatusMap[activeTab];
        return flightStatuses.includes(flight.status);
    });
    const filteredOffers = offers.filter((offer) => {
        if (activeTab === 'all') {
            return true;
        }
        if (activeTab === 'pending') {
            return dictionaries_1.FlightOfferStatus[offer.status] == "PENDING";
        }
        else if (activeTab === 'completed') {
            return dictionaries_1.FlightOfferStatus[offer.status] == "DECLINED";
        }
        else
            return false;
    });
    return [...filteredFlights, ...filteredOffers].sort((a, b) => {
        const dateA = new Date(a.departure_datetime).getTime();
        const dateB = new Date(b.departure_datetime).getTime();
        return dateA - dateB;
    });
};
exports.filterFlights = filterFlights;
const renderPilotFlightPostTitle = (flightData, t) => `${t("share.pilot_flight_post_1")} ${flightData?.departure_from.city} ${t("share.to")} ${flightData?.destination_to.city} ${flightData?.departureDate} ${t("share.pilot_flight_post_2")} ${t("share.more-info")} `;
exports.renderPilotFlightPostTitle = renderPilotFlightPostTitle;
const renderPilotRequestPostTitle = (flightData, t) => `${t("share.pilot_request_post_1")} ${flightData?.departure_from.city} ${t("share.to")} ${flightData?.destination_to.city} ${flightData?.departureDate} ${t("share.pilot_request_post_2")} ${t("share.more-info")} `;
const renderPassengerFlightPostTitle = (flightData, t) => `${t("share.passenger_flight_post_1")} ${flightData?.departure_from.city} ${t("share.to")} ${flightData?.destination_to.city} ${flightData?.departureDate}. ${t("share.passenger_flight_post_2")} ${t("share.more-info")} `;
const renderPassengerRequestPostTitle = (flightData, t) => `${t("share.passenger_request_post_1")} ${flightData?.departure_from.city} ${t("share.to")} ${flightData?.destination_to.city} ${flightData?.departureDate}. ${t("share.passenger_request_post_2")} ${t("share.more-info")} `;
exports.renderPassengerRequestPostTitle = renderPassengerRequestPostTitle;
const getPostTitle = (flightData, userDetails, t) => {
    if (flightData.flight_author.id === userDetails.id) {
        return flightData.request ?
            (0, exports.renderPassengerRequestPostTitle)(flightData, t) :
            (0, exports.renderPilotFlightPostTitle)(flightData, t);
    }
    else {
        return flightData.request ?
            renderPilotRequestPostTitle(flightData, t) :
            renderPassengerFlightPostTitle(flightData, t);
    }
};
exports.getPostTitle = getPostTitle;
const getFlightUrl = (flightData) => {
    const flightLink = flightData.request ? "request-details" : "flight-details";
    return `${config_1.APP_URL}${flightLink}?id=${flightData.id}`;
};
exports.getFlightUrl = getFlightUrl;
const filterItemsByTab = (items, tab, destinationIcaoCode, departureIcaoCode) => {
    return items.filter(item => {
        if (tab === 'departure')
            return item.icao_code === departureIcaoCode;
        else if (tab === 'destination')
            return item.icao_code === destinationIcaoCode;
    });
};
exports.filterItemsByTab = filterItemsByTab;
const getCityToCityText = (flightData) => `${flightData?.departure_from.city} > ${flightData?.destination_to.city}`;
exports.getCityToCityText = getCityToCityText;
const getTotalCost = (passengers, price) => `${(passengers * price).toFixed(2)} zł`;
exports.getTotalCost = getTotalCost;
const prepareFlightDetailsDataFromFlightOffer = (flightData, requestAuthor) => {
    const flightTime = (0, moment_1.default)(flightData.flight_time, "HH:mm:ss").format("HH:mm") + ' h';
    const isCompleted = false;
    const isOngoing = true;
    const isCanceled = false;
    const flightDates = (0, utils_1.getConvertedFlightDates)(flightData.departure_datetime, flightData.destination_eta);
    const passengersCount = (0, utils_1.calculatePassengersCount)(flightData.passengers_seats);
    return {
        ...(0, lodash_1.omit)(flightData, ['departure_datetime', 'destination_eta']),
        ...flightDates,
        flightTime,
        isCompleted,
        isOngoing,
        isCanceled,
        passengersCount,
        available_seats: 0,
        dedicated: true,
        description: '',
        flight_passengers: [],
        is_passenger: false,
        my_passengers: 0,
        passengers_seats: {},
        flight_author: requestAuthor,
        flight_offers: [],
        request: false,
        notams: [],
        metars: [],
        cancel_message: "",
        read_timestamp: null,
        type: "Flight"
    };
};
exports.prepareFlightDetailsDataFromFlightOffer = prepareFlightDetailsDataFromFlightOffer;
const canOfferFlight = (offers, user) => {
    return !offers.find(o => o.pilot.app_user?.id === user.id && dictionaries_1.FlightOfferStatus[o.status] === "PENDING");
};
exports.canOfferFlight = canOfferFlight;
